import { render, staticRenderFns } from "./testaudio.vue?vue&type=template&id=b20642a0&scoped=true&"
import script from "./testaudio.vue?vue&type=script&lang=js&"
export * from "./testaudio.vue?vue&type=script&lang=js&"
import style0 from "./testaudio.vue?vue&type=style&index=0&id=b20642a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20642a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\maixun_cxx\\private_library\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b20642a0')) {
      api.createRecord('b20642a0', component.options)
    } else {
      api.reload('b20642a0', component.options)
    }
    module.hot.accept("./testaudio.vue?vue&type=template&id=b20642a0&scoped=true&", function () {
      api.rerender('b20642a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/testaudio.vue"
export default component.exports